module.exports = __webpack_public_path__ + "static/media/ray glasses 17 degrees.5c7721c8.glb";